import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import {
  Card,
  CardContent,
  CardActions,
  Typography,
  Button,
} from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import { postSupportCommand } from 'apis/supportAPIs';

const useStyles = makeStyles((theme) => ({
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  iconRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  actions: {
    marginTop: 'auto',
    padding: theme.spacing(2),
  },
}));

const ExportPrinterSettings = ({ restaurantId, deviceId, onCommandStart }) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);

  const handleRun = useCallback(async () => {
    setLoading(true);
    try {
      const { commandId } = await postSupportCommand({
        restaurantId,
        deviceId,
        type: 'exportPrinterSettings',
        params: {},
      });
      onCommandStart(commandId, 'exportPrinterSettings');
    } catch {
      onCommandStart(null, 'exportPrinterSettings');
    } finally {
      setLoading(false);
    }
  }, [restaurantId, deviceId, onCommandStart]);

  return (
    <Card className={classes.card} aria-label="Export Printer Settings" role="region">
      <CardContent>
        <div className={classes.iconRow}>
          <PrintIcon color="primary" />
          <Typography variant="h6">Export Printer Settings</Typography>
        </div>
        <Typography variant="body2" color="textSecondary">
          Exports the current printer configuration from the device as JSON.
        </Typography>
      </CardContent>
      <CardActions className={classes.actions}>
        <Button
          variant="contained"
          onClick={handleRun}
          disabled={loading}
          fullWidth
        >
          {loading ? 'Sending…' : 'Run'}
        </Button>
      </CardActions>
    </Card>
  );
};

ExportPrinterSettings.propTypes = {
  restaurantId: PropTypes.string.isRequired,
  deviceId: PropTypes.string.isRequired,
  onCommandStart: PropTypes.func.isRequired,
};

export default ExportPrinterSettings;
